import { PkCard, PkDivider, PkIcon } from '@uefadigital/panenka-react';
import clsx from 'clsx';

import { VideoIcon } from '../VideoIcon';

import { useWindowSize } from '@shared/hooks/useWindowSize';
import PictureHelper from '@shared/PictureHelper';
import { useTranslateFn } from '@shared/Translate';
import type { UefatvEditorialContent } from '@shared-types/uefatv.types';

import * as styles from './styles.module.scss';

interface VideoListItemProps {
  item: UefatvEditorialContent;
  videoId: string;
  handleClick: (item: UefatvEditorialContent) => () => void;
  hideMetadata?: boolean;
}

const VideoListItem = ({ item, videoId, handleClick, hideMetadata }: VideoListItemProps) => {
  const t = useTranslateFn();
  const { isDesktop, isLandscape } = useWindowSize();

  const isSelected = (id: string) => {
    return videoId === id;
  };

  return (
    <>
      <div className={clsx(styles.cardContainer, isSelected(item.id) && styles.selected)}>
        {isSelected(item.id) && (
          <div className={styles.overlay}>
            <PkIcon color='interaction-high-contrast' className='pk-mr--xs2' name='av-play' size={20} />
            <div className={styles.nowPlaying}>{t('now_playing')}</div>
          </div>
        )}
        <PkCard
          aria-label={item.title}
          role='article'
          className={styles.card}
          style={{ cursor: 'pointer' }}
          onClick={handleClick(item)}
          content={isDesktop || isLandscape ? 'over' : 'default'}
          orientation={isDesktop || isLandscape ? 'portrait' : 'horizontal'}
        >
          <div slot='heading'>
            {(isDesktop || isLandscape) && <VideoIcon item={item} />}
            {item?.mainMedia?.image && (
              <PictureHelper
                image={item.mainMedia.image}
                formats={['0@w1']}
                title={item.title}
                className={styles.img}
              />
            )}
          </div>
          <div slot='body'>{!hideMetadata && <div>{item.title}</div>}</div>
        </PkCard>
      </div>
      {!isDesktop && !isLandscape && <PkDivider className={styles.divider} />}
    </>
  );
};

export default VideoListItem;
